export default __webpack_public_path__ + "static/757-f37b43891dbaff70a0fe292fbc477a5f.gif";